import RestrictMoveAndRotate from "./features/restrict-moveAndRotate";

class MeshRestrictionController {
    constructor() {
        {
            this.restrictionControllers = {
                MoveAndRotate: new RestrictMoveAndRotate(),
                Highlight: new RestrictMoveAndRotate(),
                Visibility: new RestrictMoveAndRotate(),
                Transparency: new RestrictMoveAndRotate()
            }
        }
    }

    updateRules(restrictionType = undefined, rules = [], applyTo = []) {
        const controller = this.restrictionControllers[restrictionType];
        if (controller) controller.updateRules(rules, applyTo);
    }

    isValid(restrictionType = undefined, restrictedMeshType = undefined, meshList = []) {
        const controller = this.restrictionControllers[restrictionType];
        return controller ? controller.isValid(restrictedMeshType, meshList) : true;
    }

    updateRestrictionStatus(restrictionType = undefined, status) {
        const controller = this.restrictionControllers[restrictionType];
        if (controller) controller.updateRestrictionStatus(status);
    }

    clear(restrictionType = undefined) {
        const controller = this.restrictionControllers[restrictionType];
        if (controller) controller.clear();
    }
}

let meshRestrictionController = new MeshRestrictionController();

export default meshRestrictionController;